import { landmarkTypeToSvgIconNameMap } from '@/components/customerPage/addressSearch/addressSearch.types';
import type { Landmark, PrivateBuilding, WellKnownPlace } from '@/types/customer/address.types';
import type { WellKnownPlaceDto } from '@/types';

/**
 * Type-guard validant que la "place" fournie soit une adresse publique, représenté sous forme d'objet.
 */
function isLandmark(place: unknown): place is Landmark {
  return typeof place === 'object' && place !== null;
}

/** Type-guard: valide que le type de landmark existe dans la liste des icônes supportés. */
function hasValidLandmarkType(value: string): value is keyof typeof landmarkTypeToSvgIconNameMap {
  return value in landmarkTypeToSvgIconNameMap;
}

/** type-guard: valide que l'endroit est un édifice non-public */
function isPrivateBuilding(place: WellKnownPlace | WellKnownPlaceDto | null): place is PrivateBuilding {
  return typeof place === 'string' && place.length > 0;
}

export {
  isLandmark,
  isPrivateBuilding,
  hasValidLandmarkType,
};
